import Ract, { Component } from 'react';

import Thanks from '../../../components/Thanks';
import { Input } from '../../../components/forms/input';
import axios from 'axios';
import Head from 'next/head';
import dynamic from 'next/dynamic';

const Waveform = dynamic(() => import('../../../components/Waveform'), {
  ssr: false,
});
// import Waveform from '../../../components/Waveform'

class Voice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formdata: {},
      showThanks: false,
      loadedThanks: false,
      title: props.ti,
      titleService: null,
      show: props.show,
      nda: 'No',
      recording: false,
      play: false,
      from: 'index',
      display: '',
      controllerWrapper: '',
      mediaRecorder: null,
      stateIndex: 0,
      finishRecording: false,
      isPlaying: false,
      audio: null,
      playing: false,
      pos: 0,
      blob: null,
      wavesurfer: null,
    };
    // this.canvas = null
    // this.ctx = null
    // this.startTime = null
    this.obj = {};
    this.timeOffset = 5;
    this.now = 60;
    this.mr = null;
    this.wavesufer = null;
  }
  setWavesurfer = wavesurfer => {
    this.setState({ wavesurfer });
  };
  init = () => {
    this.obj.canvas = document.getElementById('canvas');
    this.obj.ctx = this.obj.canvas.getContext('2d');
    this.obj.width = window.innerWidth * 0.7;
    this.obj.height = window.innerHeight * 1.2;
    this.obj.canvas.width = this.obj.width * window.devicePixelRatio;
    this.obj.canvas.height = this.obj.height * window.devicePixelRatio;
    this.obj.canvas.style.width = this.obj.width + 'px';
    this.obj.canvas.style.height = 50 + 'px';
    this.obj.ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
    if (document.getElementById('canvas')) {
      document.getElementById('canvas').outerHTML = '';
      document.getElementById('for-canvas').appendChild(this.obj.canvas);
    }
  };
  loop = () => {
    this.timeOffset = 50;
    this.obj.ctx.clearRect(0, 0, this.obj.canvas.width, this.obj.canvas.height);
    this.obj.analyser.getByteFrequencyData(this.obj.frequencyArray);
    let max = 0;

    if (parseInt(performance.now() / this.timeOffset) > this.now) {
      this.now = parseInt(performance.now() / this.timeOffset);
      for (var i = 0; i < this.obj.frequencyArray.length; i++) {
        if (this.obj.frequencyArray[i] > max) {
          max = this.obj.frequencyArray[i];
        }
      }

      var freq = Math.floor(max * 0.2);

      this.obj.bars.push({
        x: this.obj.width,
        y: this.obj.height / 2 - freq / 2,
        height: max,
        width: 2,
      });
    }
    this.draw();
    try {
      requestAnimationFrame(this.loop);
    } catch (e) {
      alert(e);
    }
  };
  draw = () => {
    for (let j = 0; j < this.obj.bars.length; j++) {
      const bar = this.obj.bars[j];
      this.obj.ctx.fillStyle = `#8DC63F`;
      this.obj.ctx.fillRect(bar.x, bar.y, bar.width, bar.height);
      bar.x = bar.x - 2;
      if (bar.x < 1) {
        this.obj.bars.splice(j, 1);
      }
    }
  };

  soundAllowed = stream => {
    var AudioContext = window.AudioContext || window.webkitAudioContext;
    var audioContent = new AudioContext();
    var streamSource = audioContent.createMediaStreamSource(stream);

    this.obj.analyser = audioContent.createAnalyser();
    streamSource.connect(this.obj.analyser);
    this.obj.analyser.fftSize = 512;
    this.obj.frequencyArray = new Uint8Array(this.obj.analyser.frequencyBinCount);
    this.init();
    const that = this;
    setTimeout(function () {
      that.loop();
    }, 500);
  };

  setRecording = recording => {
    this.setState({ recording });
  };
  setFinishRecording = finishRecording => {
    this.setState({ finishRecording });
  };
  setAudio = audio => {
    this.setState({ audio });
  };
  setIsPlaying = (isPlaying, from = 'index') => {
    if (from == 'index') {
      this.setState({ isPlaying });
    } else {
      // this.setState({isPlaying:false})
    }
    this.setState({ from });
  };
  handleChange = (param, value) => {
    if (param == 'nda') {
      this.setState({ nda: value });
    }
    if (param == 'service') {
      let checkboxes = document.getElementsByName('service');
      let checkboxesChecked = [];

      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          checkboxesChecked.push(checkboxes[i]);
        }
      }
      if (checkboxesChecked.length > 1) {
        this.setState({ titleService: 'Digital Services' });
      } else {
        this.setState({ titleService: null });
      }
    }
    this.setState(prevState => {
      let formdata = Object.assign({}, prevState.formdata);
      formdata[param] = value;
      return { formdata };
    });
  };
  hideThanksModal = () => {
    this.setState({ showModal: false, titleService: null, showThanks: false, loadedThanks: false });
    document.body.style.overflow = 'auto';

    document.body.style.overflowX = 'hidden';
  };
  onSubmit(e) {
    e.preventDefault();

    var that = this;

    var form_data = new FormData(e.target);

    for (var key in this.state.formdata) {
      form_data.append(key, this.state.formdata[key]);
    }

    form_data.append('country', this.props.country);
    form_data.append('voice', this.state.blob);

    // that.setState({showThanks:true});

    document.body.style.overflow = 'hidden';

    axios.post('https://mailer.weprodigi.com/api/v1/get-voice-proposal', form_data).then(response => {
      // that.setState({loadedThanks:true});
      // location.reload()
      window.location.href = 'https://weprodigi.com/thank-you';
    });
    // e.target.reset()
  }
  hide = () => {
    this.setState({ showModal: false, titleService: null, showThanks: false, loadedThanks: false });
    document.getElementById('voice-form').reset();
  };
  record = () => {
    const that = this;
    this.obj.bars = [];
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({
          audio: true,
        })
        .then(stream => {
          that.soundAllowed(stream);
          let chunks = [];

          let mediaRecorder = new MediaRecorder(stream);
          mediaRecorder.ondataavailable = e => {
            chunks.push(e.data);
          };

          mediaRecorder.onstop = () => {
            const blob = new Blob(chunks, { type: 'audio/ogg; codecs=opus' });
            that.setState({ blob });

            chunks = [];

            let audioURL = window.URL.createObjectURL(blob);

            that.setAudio(audioURL);
            document.querySelector('audio').src = audioURL;
          };
          that.setState({ mediaRecorder });
          this.mr = mediaRecorder;
          if (that.mr) {
            that.mr.start();
            that.setRecording(true);
          }
        })
        .catch(error => {
          console.log('Following error has occured : ', error);
          // alert('Following error has occured : ',error)
        });
    } else {
      this.setState({ stateIndex: '' });
    }
    const display = document.querySelector('.display');
    const controllerWrapper = document.querySelector('.controllers');
    this.setState({ display, controllerWrapper });
  };
  stopRecording = () => {
    // if (this.state.mediaRecorder.state === 'inactive') return
    try {
      this.mr.stop();
      this.setRecording(false);
      this.setFinishRecording(true);
    } catch (err) {
      console.log(err);
    }
  };
  deleteVoice = () => {
    this.setAudio(null);
    // this.obj = {}
    this.setIsPlaying(false, 'stop');
    this.setState({ blob: null });
    if (this.state.wavesurfer) {
      this.state.wavesurfer.stop();
      this.state.wavesurfer.pause();
      this.state.wavesurfer.empty();
    }
    const that = this;
    setTimeout(function () {
      that.setFinishRecording(false);
      that.setRecording(false);
    }, 200);
  };

  componentDidMount() {}
  render() {
    const { recording, finishRecording, isPlaying, audio, from } = this.state;
    return (
      <>
        <style global jsx>
          {`
            input[type='text'],
            input[type='number'],
            textarea {
              font-size: 16px;
            }
            .recorder {
              width: calc(100% - 43px);
            }
            canvas {
              width: 100%;
            }
          `}
        </style>
        <Head>
          <title>Voice Message - Get a Proposal | Prodigi Marketing Agency</title>
          <link rel="alternate" hrefLang="en" href="https://weprodigi.com/proposals/voice-proposal" />
          <meta
            name="description"
            content="Easily request a tailored proposal from Prodigi by sending a voice message about your project. Our team will respond with a customized plan to meet your needs."
          />
          <meta property="og:url" content="https://weprodigi.com/proposals/voice-proposal" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Voice Message - Get a Proposal | Prodigi Marketing Agency" />
          <meta
            property="og:description"
            content="Easily request a tailored proposal from Prodigi by sending a voice message about your project. Our team will respond with a customized plan to meet your needs."
          />
        </Head>
        <div className="intro relative w-full bg-white bg-grid overflow-hidden">
          <div className="relative h-full md:flex md:items-center py-12p">
            <div className="container h-full md:h-auto">
              <div className="relative z-10 h-full md:h-auto flex flex-col flex-wrap justify-top md:justify-center items-start h-3/6 md:pb-90 md:mb-120 lg:mb-0 lg:pb-90">
                <h1 className="text-[44px] text-purple uppercase font-black leading-none">
                  Send <span className="block"> a Voice</span>
                  <span className="block"> message</span>
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="py-23 px-20 bg-gray-light">
          <p className={'text-12 leading-15 '}>
            Simply send a voice message providing some information about your project( your goal, deadline, budget & etc.) and one of our account
            managers will contact you with an offer.
          </p>
          <form id={'voice-form'} method="POST" onSubmit={e => this.onSubmit(e)}>
            <p className={'text-16 leading-20 text-purple capitalize font-bolder mt-20'}>
              Send a voicemessage about your <br /> project
            </p>
            {!finishRecording ? (
              <>
                {!recording && (
                  <div className="mt-10 flex justify-between" onClick={this.record}>
                    <div
                      className={'w-full h-35 bg-white rounded-5 text-gray-slider text-12 leading-15 flex items-center pl-10'}
                      onClick={this.record}
                    >
                      Click to Record
                    </div>
                    <button
                      type={'button'}
                      className={'rounded-5 ml-10 w-35 h-35 text-white flex bg-green justify-center items-center'}
                      onClick={this.record}
                    >
                      <img src="https://admin.weprodigi.com/uploads/images/home-page/mic.svg" width={15} height={23} alt="mic" />
                    </button>
                  </div>
                )}
                {/*{recording &&*/}
                <div className={`mt-10 justify-between ${recording ? 'flex' : 'hidden'}`} onClick={this.stopRecording}>
                  <div
                    className={'w-full relative h-35 bg-white rounded-5 text-gray-slider text-12 leading-15 flex items-center px-10'}
                    id={'for-canvas'}
                    onClick={this.stopRecording}
                  >
                    <canvas id="canvas" />
                    <div className="dot" />
                    <div className="dot" />
                    <div className="vertical-line" />
                  </div>
                  <button
                    type={'button'}
                    className={'rounded-5 ml-10 w-35 h-35 text-white flex bg-white justify-center items-center'}
                    onClick={this.stopRecording}
                  >
                    <img
                      src="https://admin.weprodigi.com/uploads/images/home-page/pause.svg"
                      width={15}
                      height={23}
                      alt=""
                      onClick={this.stopRecording}
                    />
                  </button>
                </div>
                {/*}*/}
              </>
            ) : (
              <>
                <div className="mt-10 flex justify-between">
                  <div
                    className={`w-full h-35 bg-white rounded-5 text-gray-slider text-12 leading-15 ${audio ? 'flex' : 'hidden'}  flex items-center px-10 overflow-hidden`}
                  >
                    {/*{audio && */}
                    <Waveform src={audio} isPlaying={isPlaying} setWavesurfer={this.setWavesurfer} from={from} />
                    {/*}*/}
                  </div>
                  {!isPlaying || from == 'stop' ? (
                    <>
                      <button
                        type={'button'}
                        className={'rounded-5 ml-10 w-35 h-35 text-white flex bg-white justify-center items-center'}
                        onClick={() => {
                          this.setIsPlaying(true, 'index');
                        }}
                      >
                        <img src="https://admin.weprodigi.com/uploads/images/home-page/play.svg" width={15} height={23} alt="play" />
                      </button>
                      <button
                        type={'button'}
                        className={'rounded-5 ml-10 w-35 h-35 text-white flex bg-white justify-center items-center'}
                        onClick={this.deleteVoice}
                      >
                        <img src="https://admin.weprodigi.com/uploads/images/home-page/deleteBlack.svg" width={15} height={23} alt="deleteBlack" />
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        type={'button'}
                        className={'rounded-5 ml-10 w-35 h-35 text-white flex bg-white justify-center items-center'}
                        onClick={() => {
                          this.setIsPlaying(false, 'index');
                        }}
                      >
                        <img src="https://admin.weprodigi.com/uploads/images/home-page/pause.svg" width={15} height={23} alt="pause" />
                      </button>
                      <button
                        type={'button'}
                        className={'rounded-5 ml-10 w-35 h-35 text-white flex bg-white justify-center items-center'}
                        onClick={this.deleteVoice}
                      >
                        <img src="https://admin.weprodigi.com/uploads/images/home-page/delete.svg" width={15} height={23} alt="delete" />
                      </button>
                    </>
                  )}
                </div>
              </>
            )}

            <div className="mt-20">
              <p className={'text-16 leading-20 text-purple capitalize font-bolder mt-20'}>Your Name *</p>
              <div className="mt-10">
                <Input type="text" name="name" bg="bg-white" required={true} onChange={this.handleChange} />
              </div>
            </div>
            <div className="mt-20">
              <p className={'text-16 leading-20 text-purple capitalize font-bolder mt-20'}>Your Email *</p>
              <div className="mt-10">
                <Input type="text" name="email" bg="bg-white" required={true} onChange={this.handleChange} />
              </div>
            </div>
            <div className="mt-20">
              <p className={'text-16 leading-20 text-purple capitalize font-bolder mt-20'}>Your Phone Number </p>
              <div className="mb-10">
                <Input type="number" name="phone" bg="bg-white" required={false} onChange={this.handleChange} />
              </div>
            </div>
            <p className={'text-16 text-purple font-bolder mt-20'}>What’s the best way to contact you?</p>
            <div className="flex flex-row mt-10">
              <div className="form-group mr-30">
                <div className="radio-item">
                  <input
                    type="radio"
                    id="contact-via-email-1"
                    name="contact-via"
                    value="Email"
                    onChange={() => this.handleChange('contact-via', 'Email')}
                  />
                  <label htmlFor="contact-via-email-1">Email</label>
                </div>
              </div>
              <div className="form-group mr-30">
                <div className="radio-item">
                  <input
                    type="radio"
                    id="contact-via-phone-1"
                    name="contact-via"
                    value="Phone"
                    onChange={() => this.handleChange('contact-via', 'Phone')}
                  />
                  <label htmlFor="contact-via-phone-1">Phone</label>
                </div>
              </div>
              <div className="form-group mr-30">
                <div className="radio-item">
                  <input
                    type="radio"
                    id="contact-via-both-1"
                    name="contact-via"
                    value="Both"
                    onChange={() => this.handleChange('contact-via', 'Both')}
                  />
                  <label htmlFor="contact-via-both-1">Both</label>
                </div>
              </div>
            </div>
            <p className="text-14 mt-15 font-bolder text-black mb-5">Send NDA</p>
            <div className={'flex justify-between mt-10'}>
              <div className="form-group    w-half">
                <div className="radio-item">
                  <input
                    type="radio"
                    id="nda-yes-1"
                    name="nda"
                    value="Yes"
                    onChange={() => {
                      this.handleChange('nda', 'Yes');
                    }}
                  />
                  <label htmlFor="nda-yes-1">Yes</label>
                </div>
              </div>
              <div className="form-group mr-5  ml-10 w-half">
                <div className="radio-item">
                  <input
                    type="radio"
                    id="nda-no-1"
                    name="nda"
                    value="No"
                    onChange={() => {
                      this.handleChange('nda', 'No');
                    }}
                  />
                  <label htmlFor="nda-no-1">No</label>
                </div>
              </div>
            </div>
            <div className={'mt-20 text-center'}>
              <button id={'offer-submit'} className={'text-white bg-green rounded-5 px-20 py-5 capitalize'} type="submit">
                submit
              </button>
            </div>
          </form>
        </div>
        <audio controls className="hidden">
          Your browser does not support the audio element.
        </audio>
        <Thanks show={this.state.showThanks} loaded={this.state.loadedThanks} hide={this.hideThanksModal}>
          Thank you for reaching out to us! One of our account managers will contact you and confirm your request. If you don’t receive an email from
          us within 24 hours please check your Spam Box.
        </Thanks>
      </>
    );
  }
}
export default Voice;
